import { createEntityAdapter, EntityState } from "@ngrx/entity";
import { createReducer, on } from "@ngrx/store";
import { ProcedureApiActions } from "../actions/action-index";
import { Procedure } from "./procedure";

export const featureKey = "procedures";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ProcedureState extends EntityState<Procedure> {}

export const adapter = createEntityAdapter<Procedure>({
  selectId: (fee) => fee.id,
  sortComparer: (a, b) => a.code.localeCompare(b.code),
});

export const initialState: ProcedureState = adapter.getInitialState();

export const reducer = createReducer(
  initialState,
  on(ProcedureApiActions.loadSuccess, (state, { procedures }) =>
    adapter.setAll(
      procedures.map(
        (p) =>
          ({
            category: p.Category ?? null,
            code: p.Code,
            id: p.Id,
          } as Procedure)
      ),
      state
    )
  )
);
